import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';

/**
 * Carga los archivos de traducción JSON desde `assets/i18n/{lang}.json`.
 *
 * La ruta es relativa (sin `/` inicial) para que se resuelva contra el `<base href>`
 * del index.html — funciona tanto en dev (`/`) como en prod (`/Partnercore/`).
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`assets/i18n/${lang}.json`);
  }
}
